import { createGlobalState, useStorage } from '@vueuse/core'

export const useGlobalAuthToken = createGlobalState(
  () => useStorage('wetix-auth-token', null)
)
